import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { CreateFreebetsForm } from './CreateFreebetsForm';

// Styles
import { useCreateFreebets } from '@Modal/hooks/freebets/useCreateFreebets';

export const CreateFreebetsModalDialog = () => {
  const { showCreateFreebetsForm, handleCreateCancel } = useCreateFreebets();

  return (
    <>
      {showCreateFreebetsForm && (
        <ClosableModal
          name="CreateFreebets"
          title="Create Freebets"
          open={showCreateFreebetsForm}
          onClose={handleCreateCancel}
          sx={{ width: '592px', overflowY: 'scroll', maxHeight: '90vh' }}
        >
          <CreateFreebetsForm />
        </ClosableModal>
      )}
    </>
  );
};
